export enum ChannelListFilterRowLabel {
  ConversationStatus = 'Conversation Status',
  ConversationAssignees = 'Conversation Assignees',
  ConversationTags = 'Conversation Tags',
  AppointmentProviders = 'Appointment Providers',
  AppointmentTypes = 'Appointment Types',
  AppointmentRooms = 'Appointment Rooms',
}
